import { useCallback, useEffect } from "react";
import FormContainer from "../../../../../../common/components/form_container";
import { UseFormReturn } from "react-hook-form";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ProjetoInformacoesForm } from "../../../schemas/Projetos_cadastro/Projeto_Informacoes";
import { DropDownFuncionario } from "../../../../../../common/components/dropdown_funcionario";
import { InformacoesLista } from "../../../../domain/models/informacoes_lista";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";

type Props = {
  open: boolean;
  saving: boolean;
  selectedInfo: InformacoesLista | null;
  hookForm: UseFormReturn<ProjetoInformacoesForm>;
  onClose: () => void;
  onSubmit: (form: ProjetoInformacoesForm) => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void;
};

export const InformacoesProjetoModelContent = (
  { open, hookForm, selectedInfo, saving, onClose, onOpenChangeHistory, onSubmit }: Props) => {


  useEffect(() => {
    if (selectedInfo) {
      hookForm.setValue("data", selectedInfo.Data);
      hookForm.setValue("descInformacoes", selectedInfo.DescInformacoes);
      hookForm.setValue("idFuncionario", selectedInfo.IdFuncionario);
      hookForm.setValue("idInformacoes", selectedInfo.IdInformacoes);
      hookForm.setValue("idProjeto", selectedInfo.IdProjeto);
    } else {
      hookForm.reset({});
    }
  }, [hookForm, selectedInfo]);

  const handleSubmit = useCallback(
    (form: ProjetoInformacoesForm) => {
      if (!saving) onSubmit(form);
    },
    [saving, onSubmit],
  );
  const handleError = useCallback((errors: any) => {
    console.error("Zod bloqueou o form! Veja os erros abaixo:");
    console.log(errors);
  }, []);

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

  const handleChangeHistory = useCallback(() => {
    if (selectedInfo) {
      onOpenChangeHistory(selectedInfo.IdInformacoes, LogTipoTabela.INFORMACOES);
    }
  }, [selectedInfo, onOpenChangeHistory]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            component: "form",
            onSubmit: hookForm.handleSubmit(handleSubmit, handleError),
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "42rem",
            },
          },
        }}
      >
        <DialogTitle>Informações do Projeto</DialogTitle>
        <DialogContent>
          <ModalLoading loading={saving}>
            <FormContainer title={selectedInfo ? "Editar" : "Cadastrar"} arrangement="fullRow">
              <>
                <DropDownFuncionario label="Responsável" name="idFuncionario" required={true} reactHookForm={hookForm} />

                <FormDatePickerInput name="data" label="Data" reactHookForm={hookForm} required={true} />

                <DefaultFormInput
                  name="descInformacoes"
                  label="Informações"
                  required={true}
                  multiline
                  rows={3}
                  readOnly={saving}
                  reactHookForm={hookForm}
                />
              </>
            </FormContainer>
            <DialogActions>
              <div className="w-full h-full items-center justify-between flex p-4 gap-4">
                <div className="w-[220px]">
                  {
                    isNotNullOrUndefined(selectedInfo) &&
                    <PrimaryButton
                      buttonColor="yellow"
                      onClick={handleChangeHistory}>
                      <span className="text-xs">
                        Historico de alterações
                      </span>
                    </PrimaryButton>
                  }
                </div>
                <div className="flex flex-row gap-2 w-full justify-end">
                  <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                    <h1
                      className="text-sm text-black dark:text-white"
                      onClick={handleClose}>
                      Cancelar
                    </h1>
                  </div>

                  <div className="w-[120px]">
                    {saving ? (
                      <PrimaryButton
                        buttonColor="primary-green">
                        Salvando...
                      </PrimaryButton>
                    ) : (
                      <PrimaryButton
                        type="submit"
                        buttonColor="primary-green">
                        Salvar
                      </PrimaryButton>
                    )}
                  </div>
                </div>
              </div>
            </DialogActions>
          </ModalLoading>
        </DialogContent>
      </Dialog>
    </>
  );
};
